// Message bubble with non‑payload content, such as an indicator of deleted content or a date stamp.

import React from 'react';

export default class MetaMessage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  // 👉 вызываем onSendMessage при клике
  handleClick(e) {
    e.preventDefault();                                // не переходим по ссылке
    const { onSendMessage, intl } = this.props;
    if (onSendMessage) {
      onSendMessage(intl.formatMessage({ id: 'hello' }));
      //onSendMessage("Привет");
    }
  }

  render() {
    let content = null;
    let bubbleClass = 'bubble';

    if (this.props.date) {
      if (this.props.typeDialog && this.props.typeDialog === 3) {
        content = <>{this.props.intl.formatMessage({ id: 'dialog.nextaction.train' })}</>;
      } else if (this.props.typeDialog && this.props.typeDialog !== 3) {
        content = (
          <>
            {this.props.intl.formatMessage({ id: 'dialog.nextaction' })} {" "}
            <a href="#" onClick={this.handleClick}>{this.props.intl.formatMessage({ id: 'hello' })}</a>
          </>
        );
      } else {
        content = <>{this.props.date}</>;
      }

      bubbleClass += this.props.upper ? ' date' : ' text';
    }

    if (!content) {
      return null;
    }

    return (
      <li className="meta">
        <div className={bubbleClass}>
          <div className="message-content">{content}</div>
        </div>
      </li>
    );
  }
}
